import pendingUserListToManage from './appStores/pending-user-list-to-manage-store'
import UserListToManage from './appStores/user-list-to-manage-store'

class RootStore {
    pendingUserListToManageStore = new pendingUserListToManage()
    userListToManageStore = new UserListToManage()
}

export default RootStore